import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <p>{`京都のWeb系自社開発企業でソフトウェアエンジニアをしてます。`}</p>
    <p>{`週末は、まだ行ったことがない飲食店へ行っています。`}</p>
    <p>{`Web開発、機械学習など興味ある分野なら何でもやります。`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      